<template>
    <v-card-title class="dialog-header">
        <v-btn rounded="lg" v-show="mobile" :disabled="loading" variant="outlined" icon="mdi-close"
            class="dialog-header-close-btn-mobile" @click="$emit('close')"></v-btn>
            <v-btn v-show="!mobile" icon="mdi-arrow-left" :to="/table/ + this.rawLeads.ownerTable"
            variant="flat"></v-btn>
        <div class="dialog-header-name">
            <h1>{{ rawLeads._id }}</h1>
        </div>
        <div class="dialog-header-buttons-right">
            <v-btn rounded="lg" :to="/table/ + this.rawLeads.ownerTable"  variant="outlined" class="dialog-header-navigation-buttons">Kampagne</v-btn>
            <v-btn rounded="lg" v-show="!mobile" :disabled="loading" flat icon="mdi-close"
                class="dialog-header-close-btn" @click="$emit('close')"></v-btn>
        </div>
    </v-card-title>
</template>

<script>
import { mapState } from 'vuex';
import { useDisplay } from 'vuetify'

export default {
    props: {
        rawLeads: {
            type: Object,
            required: true
        }
    },
    setup() {
        const { mobile } = useDisplay();
        return { mobile };
    },
    computed: {
        ...mapState('rawLead', ['loading']),
    },
};
</script>

<style lang="scss" scoped></style>